import React, { createContext, useContext } from "react";
import {
  useNotifChannels,
  useCreateNotifChannel,
  useUpdateNotifChannel,
  useRemoveNotifChannel,
  useMailTargets,
  useCreateMailTarget,
  useUpdateMailTarget,
  useRemoveMailTarget,
  useSMTPs,
  useCreateSMTP,
  useUpdateSMTP,
  useRemoveSMTP,
} from "hooks/v1/pages/system-setting/useNotifChannels"; // Update this path if necessary

// Membuat context untuk loading
const NotifChannelContext = createContext();

// Provider untuk context loading
// Provider untuk context loading
export const NotifChannelProvider = ({ children }) => {
  const notifChannelHook = useNotifChannels();
  console.log("notifChannelHook", notifChannelHook);
  const createNotifChannelHook = useCreateNotifChannel({
    notifChannels: notifChannelHook.notifChannels,
    setNotifChannels: notifChannelHook.setNotifChannels,
  });

  const mailTargetHook = useMailTargets();
  const createMailTargetHook = useCreateMailTarget({
    mailTargets: mailTargetHook.mailTargets,
    setMailTargets: mailTargetHook.setMailTargets,
  });

  // Memanggil useSMTP untuk mendapatkan smtpSettings dan setSMTP
  const smtpHook = useSMTPs(); // Ini untuk mengambil data SMTP
  const createSMTPHook = useCreateSMTP({
    smtpSettings: smtpHook.smtpSettings, // Pasangkan smtpSettings dari smtpHook
    setSmtpSettings: smtpHook.setSmtpSettings, // Pasangkan setSmtpSettings dari smtpHook
  });

  const contextValue = {
    ...notifChannelHook,
    ...createNotifChannelHook,
    ...mailTargetHook,
    ...createMailTargetHook,
    ...smtpHook, // Menyertakan smtpHook yang berisi smtpSettings dan setSmtpSettings
    ...createSMTPHook, // Menyertakan createSMTPHook untuk membuat SMTP
  };

  return (
    <NotifChannelContext.Provider value={contextValue}>
      {children}
    </NotifChannelContext.Provider>
  );
};

// Hook untuk mengakses context loading
export const useNotifChannel = () => {
  const context = useContext(NotifChannelContext);
  if (!context) {
    throw new Error(
      "useNotifChannel must be used within a NotifChannelProvider"
    );
  }
  return context;
};

export const useMailTarget = () => {
  const context = useContext(NotifChannelContext);
  if (!context) {
    throw new Error("useMailTarget must be used within a NotifChannelProvider");
  }
  return context;
};

export const useSMTP = () => {
  const context = useContext(NotifChannelContext);
  if (!context) {
    throw new Error("useMailTarget must be used within a NotifChannelProvider");
  }
  return context;
};

// export const useSMTP = () => {
//   const context = useContext(NotifChannelContext);
//   if (!context) {
//     console.error("useSMTP must be used within a NotifChannelProvider");
//     throw new Error("useSMTP must be used within a NotifChannelProvider");
//   }

//   console.log("useSMTP context:", context); // Debug log
//   return context;
// };
